document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('[data-cyo]');
  if (!container) return;

  const tierInputs = container.querySelectorAll('input[name="cyo_tier"]');
  const tierValueProperty = container.querySelector('[data-cyo-tier-value]');
  const allSelects = container.querySelectorAll('select');

  function updateTierUI(selectedTier) {
    // 1. Update the hidden "Build Tier" property for the order dashboard
    if (tierValueProperty) {
      tierValueProperty.value = selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1);
    }

    // 2. Filter dropdown options based on tier
    allSelects.forEach(select => {
      let firstValidOption = null;
      let currentSelectionStillValid = false;

      Array.from(select.options).forEach(option => {
        const optionTier = option.getAttribute('data-tier');
        
        // If an option has no data-tier (like Sheath Orientation), it's always visible
        if (!optionTier) return; 

        // Visibility Logic
        const isVisible = 
          (selectedTier === 'base' && optionTier === 'base') ||
          (selectedTier === 'mid' && (optionTier === 'base' || optionTier === 'mid')) ||
          (selectedTier === 'premium');

        option.disabled = !isVisible;
        option.hidden = !isVisible;

        if (isVisible && !firstValidOption) firstValidOption = option;
        if (isVisible && select.value === option.value) currentSelectionStillValid = true;
      });

      // Reset selection if the current choice is now invalid for this tier
      if (!currentSelectionStillValid && firstValidOption) {
        select.value = firstValidOption.value;
      }
    });

    // 3. Toggle Visibility of the "Additional Add-Ons" group (Liner, Jimping, etc)
    const addOnsGroup = container.querySelector('.cyo-option-group[data-tier="mid"]');
    if (addOnsGroup) {
      addOnsGroup.style.display = (selectedTier === 'base') ? 'none' : 'block';
    }
  }

  tierInputs.forEach(input => {
    input.addEventListener('change', (e) => updateTierUI(e.target.value));
  });

  // Run once on load
  const initialTier = container.querySelector('input[name="cyo_tier"]:checked').value;
  updateTierUI(initialTier);
});